import defineComponent from 'flight';
import BubbledFocus from 'static/script/utils/bubbled-focus';

function PrefilledInput() {
    this.defaultAttrs({
        prefilledInput: 'input[data-prefilled-input]'
    });

    this._clear = function (evt) {
        let $target = $(evt.target);
        $target.val('');
    };

    this.after('initialize', function () {
        this.focus(this.attr.prefilledInput, this._clear.bind(this));
    });
}

export default defineComponent.component(PrefilledInput, BubbledFocus);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/prefilled-input.js